import type { StoryblokRichTextResolvers, StoryblokRichTextNodeResolver } from '@storyblok/richtext'
import { BlockTypes, MarkTypes } from '@storyblok/richtext'
import { blockquotes, heading, listItem, olList, paragraph, ulList } from '#layers/storyblok/app/utils/block-types'
import { anchor, link, styled } from '#layers/storyblok/app/utils/mark-types'
import { renderComponentNode } from '#layers/storyblok/app/utils/component-types'

export const defineResolvers = (resolvers: StoryblokRichTextResolvers<VNode> & {
  components?: Record<string, StoryblokRichTextNodeResolver<VNode>>
}) => {
  const {
    components = resolvers?.components || {},
    ...restResolvers
  } = resolvers || {}

  return {
    [BlockTypes.DOCUMENT]: ({ children }) => children,
    [BlockTypes.PARAGRAPH]: paragraph(),
    [BlockTypes.UL_LIST]: ulList(),
    [BlockTypes.OL_LIST]: olList(),
    [BlockTypes.LIST_ITEM]: listItem(),
    [BlockTypes.QUOTE]: blockquotes(),
    [BlockTypes.HEADING]: heading(),
    [MarkTypes.LINK]: link(),
    [MarkTypes.ANCHOR]: anchor(),
    [MarkTypes.STYLED]: styled(),
    ...restResolvers,
    [BlockTypes.COMPONENT]: node => renderComponentNode(node, components),
  }
}
